import axios from 'axios';
import { API_URL } from '../../lib/const';

export const fetchDocumentSystemConfig = () =>
  axios.get(`${API_URL}/documents/system-config`).then((r) => r.data);

export const fetchHsTranscriptReasons = () =>
  axios
    .get(`${API_URL}/documents/hs-transcript-reasons`, { params: { active: 'true' } })
    .then((r) => r.data);

export const fetchHsTranscriptCheck = (enrollmentToken) =>
  axios
    .get(`${API_URL}/documents/hs-transcript-check/${enrollmentToken}`)
    .then((r) => r.data);

export const saveHsTranscriptCheck = (enrollmentToken, data) =>
  axios
    .patch(`${API_URL}/documents/hs-transcript-check/${enrollmentToken}`, data)
    .then((r) => r.data);
